import React from "react"
import PropTypes from "prop-types"
import { childParser } from "containers/utilities"
import { animate } from "utils"
import Radium from "higher-order-components/configured-radium/"

/**
 * Render an image component
 * @param {Number} zIndex - set CSS zIndex attribute.
 * @param {'absolute'|'relative'} position - sets CSS position attribute.
 * @param {'left'|'right'|'center'} backgroundPosition - sets CSS backgroundPosition attribute.
 * @param {'contain'|'cover'} backgroundSize - sets CSS backgroundSize attribute.
 * @param {'top'|'bottom'|'center'} [textVerticalAlign=center] - Vertical text alignment.
 * @param {Boolean} flex - Applys flex:1 to fill display:flex parents.
 * @param {String} src - URL for image asset.
 * @returns {ReactElement} React Component
 */
const BackgroundImage = ({
  zIndex,
  position,
  backgroundPosition,
  backgroundSize,
  textVerticalAlign,
  flex,
  src,
  transition,
  components,
  children
}) => (
  <div
    data-test="background-image"
    style={[
      styles.base,
      styles.verticalAlign(textVerticalAlign),
      { backgroundImage: "url(" + src + ")" },
      backgroundSize ? { backgroundSize } : { backgroundSize: "cover" },
      zIndex ? { zIndex } : "",
      position ? { position } : "",
      backgroundPosition ? { backgroundPosition } : "",
      animate(transition),
      flex ? styles.flex : styles.fill
    ]}>
    {childParser({ components, children })}
  </div>
)

export default Radium(BackgroundImage)

BackgroundImage.propTypes = {
  zIndex: PropTypes.number,
  position: PropTypes.oneOf(["absolute", "relative"]),
  backgroundPosition: PropTypes.oneOf(["left", "right", "center", "top"]),
  backgroundSize: PropTypes.oneOf(["contain", "cover"]),
  textVerticalAlign: PropTypes.oneOf(["top", "bottom", "center"]),
  flex: PropTypes.bool,
  transition: PropTypes.string,
  src: PropTypes.string.isRequired,
  components: PropTypes.array,
  children: PropTypes.node
}
BackgroundImage.defaultProps = {
  textVerticalAlign: "center",
  backgroundSize: "cover"
}

const styles = {
  base: {
    textAlign: "center",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    color: "white",
    display: "flex",
    position: "relative",
    overflow: "hidden",
    zIndex: 0
  },
  verticalAlign: alignment => ({
    alignItems: alignment === "bottom" ? "flex-end" : alignment === "top" ? "top" : "center"
  }),
  fill: {
    width: "100%",
    height: "100%"
  },
  flex: {
    flex: "1 1 auto"
  }
}



// WEBPACK FOOTER //
// ./src/containers/background-image/index.jsx